export default class StorePickupZone{
    id: number = 0;
}  